import { render, staticRenderFns } from "./ModelsSection.vue?vue&type=template&id=3b555055&scoped=true&"
import script from "./ModelsSection.vue?vue&type=script&lang=js&"
export * from "./ModelsSection.vue?vue&type=script&lang=js&"
import style0 from "./ModelsSection.vue?vue&type=style&index=0&id=3b555055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b555055",
  null
  
)

export default component.exports